import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTheme } from '@emotion/react';
export const CaretIcon = ({ color, ...props }) => {
    const theme = useTheme();
    return (_jsx("svg", { width: "24", height: "24", opacity: "0.7", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.74694 7.69666L4.22182 9.22178L12 17L19.7782 9.22178L18.253 7.69666L12 13.9497L5.74694 7.69666Z", fill: color ?? theme.colors.grey90 }) }));
};
//# sourceMappingURL=caret_icon.js.map